var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Text, TextFontSize } from '@philips-internal/oswald-ui-components';
import { Markup } from 'interweave';
import HtmlViewerAPI from './html-viewer-api';
import './html-viewer.css';
let HtmlViewer = class HtmlViewer extends Component {
    static { this.propTypes = {
        htmlContent: string,
        title: string
    }; }
    wrapDocument(doc) {
        return `
  <!doctype html>
  <html>
  <body onload="watedoc.onLoad()">
    ${doc}
  </body>
  </html>
  `;
    }
    renderTitle() {
        const { title } = this.props;
        if (!title) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: "html-viewer-title-container" },
            React.createElement(Text, { className: 'html-viewer-title', value: title, size: TextFontSize.MEDIUM, bold: true })));
    }
    render() {
        const { htmlContent } = this.props;
        const html = this.wrapDocument(htmlContent);
        return (React.createElement("div", { className: "html-viewer-container" },
            React.createElement("div", { className: "html-viewer-content" },
                this.renderTitle(),
                React.createElement(Markup, { content: html }))));
    }
};
HtmlViewer = __decorate([
    AwesomeComponent({ api: HtmlViewerAPI, type: ComponentType.DATA_DISPLAY })
], HtmlViewer);
export default HtmlViewer;
//# sourceMappingURL=html-viewer.js.map